module.exports = __webpack_public_path__ + "static/media/check-mark.44731ff2.png";